import { isEmpty, merge, isNull } from 'lodash';
import { FILTER } from '../../constants/actionTypes';
import serializeUrl from '../../utils/serialize_url';
import { routes } from '../../constants/config';
import { getSharedParams } from '../shared/utils';

export const initialState = {
  date: null,
  type: 'any',
  creator: null,
  tags: null,
  page: 1,
  query: '',
  sort: {
    column: 'title',
    direction: 'asc',
  },
  perPage: 10,
  workspace: 'all',
};

const getParams = ({
  tags,
  creator,
  query,
  page,
  type,
  date,
  sort,
  perPage,
  workspace,
}) => {
  const params = getSharedParams({
    page,
    query,
    type,
    date,
    sort,
    perPage,
    initialState,
  });
  if (!isEmpty(tags)) params.tags = tags;
  if (creator !== 'any' && !isNull(creator)) params.creator = creator;
  if (type !== 'any') params.type = type;
  if (workspace !== 'all') params.workspace = workspace;
  return params;
};

const getNewState = (state, changes) => {
  const newState = { ...state, ...changes };
  const { type, creator, tags, query, date, workspace } = newState;
  newState.isActive = [
    type === 'any',
    creator === 'any' || isNull(creator),
    workspace === 'all',
    isEmpty(tags),
    isEmpty(query),
    isEmpty(date),
  ].some(filter => !filter);
  newState.page = (!!changes && changes.page) || 1;

  // This hacky bit basically says if a content type has changed,
  // clear out the sort filter because the table headers may not match.
  if (changes && isEmpty(changes.url) && changes.type && !changes.sort) {
    newState.sort.column =
      changes.type === 'fresh_content' ? 'freshness-score' : 'title';
    newState.sort.direction = changes.type === 'fresh_content' ? 'desc' : 'asc';
  }

  newState.url = serializeUrl(routes.CONTENT.INDEX, getParams(newState));

  return newState;
};

export const currentFilter = (state, action) => {
  switch (action.type) {
    case FILTER.UPDATE.TAGS: {
      return getNewState(state, {
        tags: action.tags,
      });
    }

    case FILTER.UPDATE.PAGE:
      return getNewState(state, {
        page: action.page,
      });

    case FILTER.UPDATE.DATE:
      return getNewState(state, {
        date: action.date,
      });

    case FILTER.UPDATE.CREATOR:
      return getNewState(state, {
        creator: action.id,
      });
    case FILTER.UPDATE.WORKSPACE:
      return getNewState(state, {
        workspace: action.id,
      });

    case FILTER.UPDATE.CONTENT_TYPE:
      return getNewState(state, {
        type: action.contentType,
      });

    case FILTER.UPDATE.QUERY:
      return getNewState(state, {
        query: action.query,
      });

    case FILTER.UPDATE.PER_PAGE:
      return getNewState(state, {
        perPage: action.perPage,
      });

    case FILTER.UPDATE.ALL:
      return getNewState(state, action.filter);

    case FILTER.CLEAR:
      return getNewState(
        state,
        merge({}, initialState, {
          perPage: state.perPage,
        }),
      );

    case FILTER.SORT: {
      let direction = action.sortType === 'numeric' ? 'desc' : 'asc';
      if (state.sort.column === action.sortOn) {
        direction = state.sort.direction === 'asc' ? 'desc' : 'asc';
      }

      return getNewState(state, {
        sort: {
          column: action.sortOn,
          direction,
        },
      });
    }

    default:
      return getNewState(initialState, state);
  }
};
